import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-row justify-between rounded-md border border-yellow-lp-100 bg-yellow-lp-400 px-4 py-3"
}
const _hoisted_2 = { class: "flex flex-col" }
const _hoisted_3 = { class: "text-16px font-semibold font-montserrat text-black" }
const _hoisted_4 = { class: "text-12px font-normal text-gray-lp-800" }
const _hoisted_5 = { class: "flex gap-x-2" }
const _hoisted_6 = {
  key: 1,
  class: "flex flex-row items-center gap-x-4 rounded-md border bg-gray-lp-1500 px-4 py-3"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M5.63604 5.63616C7.32387 3.94833 9.61305 3.00012 12 3.00012C14.3869 3.00012 16.6761 3.94833 18.364 5.63616C20.0518 7.32399 21 9.61317 21 12.0001C21 13.182 20.7672 14.3523 20.3149 15.4443C19.8626 16.5362 19.1997 17.5284 18.364 18.3641C17.5282 19.1998 16.5361 19.8627 15.4442 20.315C14.3522 20.7673 13.1819 21.0001 12 21.0001C10.8181 21.0001 9.64778 20.7673 8.55585 20.315C7.46392 19.8627 6.47177 19.1998 5.63604 18.3641C4.80031 17.5284 4.13738 16.5362 3.68508 15.4443C3.23279 14.3523 3 13.182 3 12.0001C3 9.61317 3.94821 7.32399 5.63604 5.63616ZM8.85 8.85012C9.20147 8.49865 9.77132 8.49865 10.1228 8.85012L12 10.7273L13.8772 8.85012C14.2287 8.49865 14.7985 8.49865 15.15 8.85012C15.5015 9.20159 15.5015 9.77144 15.15 10.1229L13.2728 12.0001L15.15 13.8773C15.5015 14.2288 15.5015 14.7986 15.15 15.1501C14.7985 15.5016 14.2287 15.5016 13.8772 15.1501L12 13.2729L10.1228 15.1501C9.77132 15.5016 9.20147 15.5016 8.85 15.1501C8.49853 14.7986 8.49853 14.2288 8.85 13.8773L10.7272 12.0001L8.85 10.1229C8.49853 9.77144 8.49853 9.20159 8.85 8.85012Z",
    fill: "#B82025"
  })
], -1)
const _hoisted_8 = { class: "text-14px font-montserrat font-semibold text-gray-lp-300" }
const _hoisted_9 = { class: "pt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (!_ctx.errorMessage)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("clientManagement.approval.confirmPriceChange")), 1),
            _createVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("clientManagement.approval.ensureClientAndPriceDataCorrect")), 1)
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_LpButton, {
              outline: "",
              isWidthFull: "",
              title: _ctx.$t('clientManagement.approval.reject'),
              textColor: "red-lp-300",
              onClick: _ctx.openRejectConfirmation
            }, null, 8, ["title", "onClick"]),
            _createVNode(_component_LpButton, {
              onClick: _ctx.openApprovalConfirmation,
              isWidthFull: "",
              title: _ctx.$t('clientManagement.approval.accept'),
              textColor: "white"
            }, null, 8, ["onClick", "title"])
          ])
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_6, [
          _hoisted_7,
          _createVNode("div", _hoisted_8, _toDisplayString(_ctx.errorMessage), 1)
        ])),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onRejected,
      onClose: _ctx.closeRejectConfirmation,
      title: _ctx.$t('clientManagement.approval.rejectClientSubmissionQuestion', { clientType: _ctx.clientType.toLowerCase() }),
      message: _ctx.$t('clientManagement.approval.selectRejectReasonForFixingSubmission'),
      image: "warning",
      isDisabled: _ctx.isDisableReject,
      textSuccess: _ctx.$t('clientManagement.approval.yesReject'),
      textCancel: _ctx.$t('clientManagement.infoPriceClient.back'),
      class: "px-8"
    }, {
      custom: _withCtx(() => [
        _createVNode("div", _hoisted_9, [
          (_ctx.clientType.toLowerCase() === 'cabang')
            ? (_openBlock(), _createBlock(_component_lp_input, {
                key: 0,
                type: "textarea",
                "text-area-rows": "1",
                modelValue: _ctx.selectedReason,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedReason = $event)),
                placeholder: _ctx.$t('clientManagement.approval.enterRejectReason')
              }, null, 8, ["modelValue", "placeholder"]))
            : (_openBlock(), _createBlock(_component_Select, {
                key: 1,
                class: "w-full text-left",
                dataSelect: _ctx.rejectedReasons,
                value: _ctx.selectedReason,
                isOpenMenu: _ctx.openSelect,
                onOpenSelect: () => (_ctx.openSelect = true),
                onCloseSelect: () => (_ctx.openSelect = false),
                onChooseSelect: _ctx.onSelectReason
              }, null, 8, ["dataSelect", "value", "isOpenMenu", "onOpenSelect", "onCloseSelect", "onChooseSelect"]))
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "onClose", "title", "message", "isDisabled", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.rejectConfirmation]
    ])
  ], 64))
}